export enum Roles {
    ROLE_ADMIN,
    ROLE_USER,
    ROLE_EDITOR,
}